import { AppStatus, RequestState } from '@models/Common'
import { Action } from '@utils/reducers/Action'
import { ArtistEntry, AlbumEntry } from '@models/Music'
import { genreMap } from '@api/musicbrainz'
import environment from 'config/environment'

export type MusicState = RequestState & {
  artist: string
  artists: ArtistEntry[]
  selectedArtist?: ArtistEntry
  albums: AlbumEntry[]
  selectedAlbum?: AlbumEntry
  genres: string[]
  selectedGenre?: string
}

export const initialState: MusicState = {
  status: AppStatus.IDLE,
  errorMessage: undefined,
  artist: '',
  artists: [],
  selectedArtist: undefined,
  albums: [],
  selectedAlbum: undefined,
  genres: ['', ...Object.keys(genreMap)],
  selectedGenre: undefined,
}

export enum MusicActionType {
  SearchArtistPending = 'SearchArtistPending',
  SearchArtistSuccess = 'SearchArtistSuccess',
  SearchArtistFailure = 'SearchArtistFailure',
  SelectArtist = 'SelectArtist',
  LookupAlbumsPending = 'LookupAlbumsPending',
  LookupAlbumsSuccess = 'LookupAlbumsSuccess',
  LookupAlbumsFailure = 'LookupAlbumsFailure',
  SelectAlbum = 'SelectAlbum',
  SelectGenre = 'SelectGenre',
}

const MusicReducer = (
  state: MusicState,
  action: Action<MusicActionType, string | ArtistEntry | ArtistEntry[] | AlbumEntry | AlbumEntry[] | undefined>,
): MusicState => {
  if (environment.isDev) {
    // eslint-disable-next-line no-console
    console.log({ reducer: 'music', state, action })
  }

  switch (action.type) {
    case MusicActionType.SearchArtistPending:
      return {
        ...state,
        status: AppStatus.PENDING,
        albums: [],
        selectedAlbum: undefined,
        artist: action.payload as string,
      }
    case MusicActionType.SearchArtistFailure:
      return { ...state, status: AppStatus.ERROR, errorMessage: action.payload as undefined }
    case MusicActionType.SearchArtistSuccess:
      return { ...state, status: AppStatus.IDLE, errorMessage: undefined, artists: action.payload as ArtistEntry[] }
    case MusicActionType.SelectArtist:
      return { ...state, selectedArtist: action.payload as ArtistEntry, artist: (action.payload as ArtistEntry)?.name }

    case MusicActionType.LookupAlbumsPending:
      return { ...state, status: AppStatus.PENDING, albums: [], selectedAlbum: undefined }
    case MusicActionType.LookupAlbumsFailure:
      return { ...state, status: AppStatus.ERROR, errorMessage: action.payload as undefined }
    case MusicActionType.LookupAlbumsSuccess:
      return { ...state, status: AppStatus.IDLE, errorMessage: undefined, albums: action.payload as AlbumEntry[] }
    case MusicActionType.SelectAlbum:
      return { ...state, selectedAlbum: action.payload as AlbumEntry }
    case MusicActionType.SelectGenre:
      return { ...state, selectedGenre: action.payload as string }

    default:
      return state
  }
}

export default MusicReducer
